import React, { Component, Fragment} from "react"
import { Switch, Route, Prompt, Redirect, matchPath } from "react-router-dom";
import { Formik, Form } from "formik"
import { isIOS } from 'react-device-detect';
import { manifestSchema as schema, manifestInitialValues as initialValues } from "./../../services/manifestValidationService"
import { postAllMessages, postMessage } from "./../../services/postService"
import { manifestMessageAgency as messageAgency } from "./../../utils/utils"
import ManifestFormInput from "./ManifestFormInput"
import ManifestVerification from "./ManifestFormVerification"
import ManifestConfirmation from "./ManifestRegistrationConfirmation"
import "./Manifest.scss"

class Manifest extends Component {
  state = {
    isSubmitted: false,
    hasRequestError: false
  }

  handleSubmit = (values) => {
    postAllMessages([
      postMessage(messageAgency(values))
    ])
    .then(response => {
      this.setState({isSubmitted: true}, 
        () => this.props.history.push("/manifest/confirm")
      )    
    })
    .catch(error => {
      this.setState({isSubmitted: true, hasRequestError: true}, 
        () => this.props.history.push("/manifest/confirm")
      )
    })
  }

  render() {
    return (
      <Fragment>
        <Prompt
          when={!this.state.isSubmitted && !isIOS}
          message={({ pathname }) => {
            return matchPath(pathname, { path: "/manifest/register" }) || matchPath(pathname, { path: "/manifest/verify" })
              ? true
              : "Wollen Sie das Formular Bordmanifest verlassen?";
          }}
        />
        <Formik 
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, actions) => {
            actions.setSubmitting(false)
            this.handleSubmit(values)
          }}
          isInitialValid={process.env.NODE_ENV === "development" ? true : false}
          render={({errors, touched, isSubmitting, isValid, values}) => {
            const renderProps = {
              errors, 
              touched, 
              isSubmitting, 
              isValid,
              values,
              ...this.state
            }
            
            return (
              <Form className="content-wrapper">
                <Switch>
                  <Redirect from="/manifest" exact to="/manifest/register" />
                  <Route path="/manifest/register"  render={(props) => <ManifestFormInput     {...props} {...renderProps} />} />
                  <Route path="/manifest/verify"    render={(props) => <ManifestVerification  {...props} {...renderProps} />} />               
                  <Route path="/manifest/confirm"   render={(props) => <ManifestConfirmation  {...props} {...renderProps} />} />               
                </Switch>
              </Form>
            )
          }}
        />
      </Fragment>
    )
  }
}

export default Manifest